module.exports = __webpack_public_path__ + "4b88f5b02f85163c14043c0d50b2cbdd-markers_img_1_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/markers/assets/markers_img_1_2x.png
// module id = 765
// module chunks = 0